/**
 * Interface for dynamic query property selector
 */
interface PropertySelectorApiModel {
  propertyName: string;
}

/**
 * Interface for dynamic query API model
 */
interface DynamicQueryApiModel {
  properties: PropertySelectorApiModel[];
}

/**
 * Creates a dynamic query body for API requests
 * @param propertyNames - Array of property names to include in the query
 * @returns The dynamic query body object
 */
export function createDynamicQueryBody(
  propertyNames: string[],
): DynamicQueryApiModel {
  return {
    properties: propertyNames.map((propertyName) => ({ propertyName })),
  };
}
